import { Chart } from "chart.js";
import { onResize } from "./chartJsPlugins";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { topLabels, htmlLegendPlugin } from './configs';


// @ts-ignore
window.initCultivateImpactBlock = (function ($, blockId, config, schoolResponse, bubbleConfigs, notUseDefaultTooltip) {
    const element = document.getElementById(config.blockId);
    const yearValue = config.year;
    let responseYears;
    if (typeof yearValue === 'string' && yearValue.trim().startsWith('[')) {
        try {
            const sanitizedJson = yearValue.replace(/'/g, '"');
            responseYears = JSON.parse(sanitizedJson);
        } catch (e) {
            responseYears = [yearValue];
        }
    } else {
        // If it's already an array, use it. If it's a plain string, wrap it.
        responseYears = Array.isArray(yearValue) ? yearValue : [yearValue];
    }
    const responceData = Array.isArray(JSON.parse(schoolResponse))
        ? JSON.parse(schoolResponse)
        : [schoolResponse];
    // @ts-ignore
    new Chart(element, {
        type: 'bar',
        data: {
            labels: responseYears,
            datasets: [{
                label: "School",
                data: responceData,
                backgroundColor: ['#50C4D9'],
                datalabels: {
                    display: false
                }
            }]
        },
        options: {
            indexAxis: 'y',
            categoryPercentage: 1,
            maintainAspectRatio: false,
            onResize: onResize,
            layout: {
                padding: {
                    right: 50
                }
            },
            scales: {
                x: {
                    grid: {
                        display: false
                    },
                    beginAtZero: true,
                    min: 0,
                    max: 100,
                    title: {
                        display: true,
                        text: '% of Students',
                    }
                },
                y: {
                    grid: {
                        display: false
                    },
                    max: 50
                }
            },
            plugins: {
                legend: { display: false },
                // leaving this here becasue there's a chance we need to re-enable it. right now, this only has school level
                // data so we don't need the toggle legend
                // htmlLegend: {
                //     containerID: `${blockId}-cultivate-impact`
                // },
                tooltip: {
                    enabled: false
                },
                datalabels: {
                    color: ['#ffffff'],
                    font: {
                        size: 14,
                        weight: 500,
                        family: "\"Roboto\", Arial, sans-serif"
                    },

                }
            }
        },
        plugins: [ChartDataLabels, topLabels, htmlLegendPlugin]

    });

});
